import 'ui-core/plugins/auto-hide-bar/js/auto-hide-bar';
import {isIE} from 'ui-core/utility/js/tests';

/*eslint-disable*/
UX.autoHideBar.displayOnScroll = function() {
    var currentTop = $(window).scrollTop(),
        secondaryNav_HeaderOffsetTop = UX.autoHideBar.$primaryBar.height();

    if (UX.autoHideBar.$stickyBar.length && UX.autoHideBar.isMobile === false && !UX.autoHideBar.disabled) {
        if (UX.autoHideBar.previousTop > currentTop && UX.autoHideBar.previousScroll !== 'up') {
            UX.autoHideBar.$primaryBar.parent().css('transform', '').addClass('fixed-element');

            if (UX.pageBody.isIE) {
                UX.autoHideBar.$stickyBar.css('top', UX.autoHideBar.$primaryBar.height());
            }
            UX.autoHideBar.previousScroll = 'up';

            if ($('.actionsbar__has__sections, .sticky-sidebar-tab, .actionsbar-book-toc, .sticky-article-actionbar').length) {
                UX.autoHideBar.updateFixedHeight('up');
            }
        } else if (
            currentTop > secondaryNav_HeaderOffsetTop &&
            UX.autoHideBar.previousTop < currentTop &&
            UX.autoHideBar.previousScroll !== 'down'
        ) {
            //if scrolling down...
            UX.autoHideBar.$primaryBar.parent()
                .removeClass('fixed-element')
                .css('transform', 'translateY(-' + UX.autoHideBar.$primaryBar.height() + 'px )');
            if (UX.pageBody.isIE) {
                UX.autoHideBar.$stickyBar.css('top', 0);
            }

            UX.autoHideBar.hideOpenHeaderMenus();
            UX.autoHideBar.previousScroll = 'down';

            if ($('.actionsbar__has__sections, .sticky-sidebar-tab, .actionsbar-book-toc, .sticky-article-actionbar').length) {
                UX.autoHideBar.updateFixedHeight('down');
            }
        }
        UX.autoHideBar.previousTop = currentTop;

        if ($('.actionsbar__has__sections').length) {
            UX.autoHideBar.removeTrans($('.actionsbar__has__sections'), $('.original-position-actionsbar'), currentTop);
        }

        if ($('.actionsbar-book-toc').length) {
            UX.autoHideBar.removeTrans($('.actionsbar-book-toc'), $('.original-position-actionsbar-book-toc'), currentTop);
        }

        if ($('.sticky-sidebar-tab').length) {
            UX.autoHideBar.removeTrans($('.sticky-sidebar-tab'), $('.original-position-tabs'), currentTop);
        }

        if ($('.sticky-article-actionbar').length) {
            UX.autoHideBar.removeTrans($('.sticky-article-actionbar'), $('.original-position-article-actionbar'), currentTop);
        }
    }
};

UX.autoHideBar.updateFixedHeight = function(dir) {
    if (dir === 'up') {
        $('.sticked').css('transform', 'translateY(' + UX.autoHideBar.$primaryBar.height() + 'px )');
    } else {
        $('.sticked').css('transform', '');
    }
};

UX.autoHideBar.init = function() {
    UX.autoHideBar.$stickyBar = $('.header--second-row');
    UX.autoHideBar.$primaryBar = $('.header__fixed-items');
    UX.autoHideBar.vPort = 'screen-md';
    if (!isIE) {
        this.header = document.querySelector(this.headerSelector);
        this.$primaryBar.addClass('auto-hide-bar fixed-element');
        this.$stickyBar.addClass('secondary-bar--sticky fixed-element');

        this.createEvents();

        setTimeout(() => {
            this.$stickyBar.css('top', this.$primaryBar.height());
        }, 200);

        this.control();
    } else {
        this.$primaryBar.removeClass('fixed');
        UX.autoHideBar.setTopMargin();
    }
};

UX.autoHideBar.additionalControls = function() {
    UX.autoHideBar.setTopMargin();

    $(window).on('orientationchange load resized', function() {
        UX.autoHideBar.setTopMargin();
    });

    if ($('.actionsbar__has__sections').length) {
        UX.autoHideBar.observe('.actionsbar__has__sections', '.original-position-actionsbar');
    }

    if ($('.actionsbar-book-toc').length) {
        UX.autoHideBar.observe('.actionsbar-book-toc', '.original-position-actionsbar-book-toc');
    }

    if ($('.sticky-sidebar-tab').length) {
        UX.autoHideBar.observe('.sticky-sidebar-tab', '.original-position-tabs');
    }
    
    if ($('.sticky-article-actionbar').length) {
        UX.autoHideBar.observe('.sticky-article-actionbar', '.original-position-article-actionbar');
    }
};
UX.autoHideBar.setTopMargin = function() {
    let topMargin = UX.autoHideBar.$primaryBar.outerHeight() + UX.autoHideBar.$stickyBar.outerHeight();
    if (isIE) {
        topMargin = UX.autoHideBar.$primaryBar.outerHeight();
    }
    $('.auto-fix')
        .next('.content')
        .addClass('auto-fix-header');
};
UX.autoHideBar.observe = function(elem, target) {
    var sticked = function() {
        document.querySelector(elem).classList.add('sticked');
    };
    var loseStickiness = function() {
        document.querySelector(elem).classList.remove('sticked');
    };

    UX.intersectionObserver.observe(target, loseStickiness, sticked);
};

UX.autoHideBar.removeTrans = function($stickyElem, $stickyOriginal, currentTop) {
    let limit = UX.autoHideBar.$stickyBar.outerHeight() + currentTop,
        val = UX.autoHideBar.$primaryBar.outerHeight() - (parseInt($stickyOriginal.offset().top) - parseInt(limit));
    // topValFixed = UX.pageBody.fixedHeight + currentTop,
    // bottomLimit = $stickyElem.parent().offset().top + $stickyElem.parent().outerHeight(),
    // bottomVal = 0;

    if ($stickyOriginal.offset().top > limit && val > 0 && UX.autoHideBar.previousScroll === 'up') {
        $stickyElem.css('transform', 'translateY(' + val + 'px )');
    } else if ((val <= 0 && UX.autoHideBar.previousScroll === 'up') || UX.autoHideBar.previousScroll === 'down') {
        $stickyElem.css('transform', '');
    }
};
